import { commonEnvironment } from './environment.common';

// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const _settings = {
  production: true,
  ApiUrl: `https://app-centauri-apistaging.azurewebsites.net/api`,
  ApiLexisNexisDevUrl: `https://app-centauri-apistaging.azurewebsites.net/api`,
  IdentityServiceUrl: `https://app-useridentitystg.azurewebsites.net`,
  GenericServiceUrl: `https://app-genericservicesstg.azurewebsites.net`,
  ClientManagementUrl: `https://app-agencyservicesstg.azurewebsites.net`,
  CentauriServiceUrl: `https://app-centauri-apistaging.azurewebsites.net`,
  CentauriRaterServiceUrl: `https://app-centauri-apiraterstaging.azurewebsites.net`,
  LoginUrl: `https://app-centauri-uistaging.azurewebsites.net`,
  BillingServiceUrl: `https://app-billing-apistaging.azurewebsites.net`,
  BillingAppId: 'CENT',
  ApplicationId: 1,
  AzureNightlyJobUrl: 'https://func-nightlyjobstaging.azurewebsites.net/api/NJDurableFunctionHTTP?code=aibyEu3mPiXg207v5yYXhaQdO/s9OaPZyK0N6XjrkMF7ch6VIFHGkw==',
  showChangeServerDate: false,
  showSkipTwoFactor: true,
  activateNightlyJob: true,
  centauriHomePageURL: 'https://centauriinsurance.com/'
};
export const environment = Object.assign({}, commonEnvironment, _settings);
